<form
  [formGroup]="searchClaimForm"
  autocomplete="off"
>
  <div class="Search-Form field-container member-id-textbox">
    <p-input-group>
      <input
        pInputText
        class="form-control"
        formControlName="claimId"
        placeholder="Check or EFT"
        data-test-id="claim-id-input"
      />
      @if (searchClaimForm.controls['claimId'].invalid && (searchClaimForm.controls['claimId'].dirty || searchClaimForm.controls['claimId'].touched)) {
        <errors-messages-inline>
          Please enter a valid EFT or Check ID
        </errors-messages-inline>
      }
      @if (searchClaimForm.controls['claimId'].hasError('claimId') && (searchClaimForm.controls['claimId'].dirty || searchClaimForm.controls['claimId'].touched)) {
        <errors-messages-inline>
          Check of EFT is <strong>required</strong>
        </errors-messages-inline>
      }
    </p-input-group>
    <div class="my-2 text-center">or</div>
    <div class="flex flex-col">
      <div class="field">
        <label class="label" data-test-id="payment-date-from-label">Payment Date From:</label>
        <p-date-picker
          #fromDate
          [readonlyInput]="false"
          [showTime]="false"
          appendTo="body"
          class="w-full"
          formControlName="paymentDateFromPicker"
          data-test-id="payment-date-from-calendar"
        />
        @if (searchClaimForm.controls['paymentDateFromPicker'].invalid && (searchClaimForm.controls['paymentDateFromPicker'].dirty || searchClaimForm.controls['paymentDateFromPicker'].touched)) {
          <errors-messages-inline
          >
            Please enter a payment date from.
          </errors-messages-inline>
        }
      </div>
      <div class="field">
        <label class="label" data-test-id="payment-date-to-label">Payment Date To:</label>
        <p-date-picker
          #toDate
          [readonlyInput]="false"
          [showTime]="false"
          appendTo="body"
          class="w-full"
          formControlName="paymentDateToPicker"
          data-test-id="payment-date-to-calendar"
        />
        @if (searchClaimForm.controls['paymentDateToPicker'].invalid && (searchClaimForm.controls['paymentDateToPicker'].dirty || searchClaimForm.controls['paymentDateToPicker'].touched)) {
          <errors-messages-inline>
            Please enter a payment date to.
          </errors-messages-inline>
        }
      </div>
      <div class="flex justify-end gap-2">
        <button
          pButton
          severity="secondary"
          type="button"
          label="Reset"
          data-test-id="claim-reset-button"
          (click)="reset()"
        ></button>
        <button
          pButton
          type="button"
          id="claim-search-form-button"
          label="Search"
          data-test-id="claim-search-button"
          (click)="searchClaims()"
          [disabled]="!searchClaimForm.valid || !this.tenantName"
        ></button>
      </div>
    </div>
  </div>
</form>

